// extracted by mini-css-extract-plugin
export default {"coll-info-wrap":"index_coll-info-wrap__J0tSu"};